import {noop} from 'lodash';
import React, {FC} from 'react';

import {Frame} from '../../common/frames/frame';
import {FrontChat} from './frontChat';
import {FrontChatCommandsEnum, FrontChatTreeData} from './types';

/*
 * Types.
 */

interface FrontChatFrameProps {
  isOpen: boolean;
  chatId: string;
  bootCommand?: FrontChatCommandsEnum;
  isDefaultLauncherEnabled?: boolean;
  isChatWindowVisible?: boolean;
  treeData?: FrontChatTreeData;
  title?: string;
  onStatusChange?: (isInitialized: boolean) => void;
  onClose: () => void;
}

/*
 * Component.
 */

export const FrontChatFrame: FC<FrontChatFrameProps> = ({
  isOpen,
  chatId,
  bootCommand,
  isDefaultLauncherEnabled,
  isChatWindowVisible,
  treeData,
  title,
  onStatusChange,
  onClose,
}) => (
  <>
    {isOpen && (
      <Frame
        minWidth="640px"
        width={720}
        height={720}
        shouldForcePopout
        onRequestClose={noop}
        interactionId="popup-widget-settings-preview"
        title={title}
      >
        <FrontChat
          chatId={chatId}
          bootCommand={bootCommand}
          isDefaultLauncherEnabled={isDefaultLauncherEnabled}
          isChatWindowVisible={isChatWindowVisible}
          treeData={treeData}
          onStatusChange={onStatusChange}
          onClose={onClose}
        />
      </Frame>
    )}
  </>
);
